import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

const AdditionalInfo = styled.div(({ theme: { palette } }) => css`
  display: flex;
  padding: 0.5rem;
  border-top: 1px solid ${palette.light.darker};
  flex-direction: column;
`)

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0;
  width: 100%;
`

const InfoLabel = styled.span(({
  theme: {
    palette, typography,
  },
}) => css`
  margin-bottom: 0.25rem;
  color: ${palette.dark.normal};
  font-size: ${typography.tiny.pt_12_medium_upper.fontSize};
  font-weight: ${typography.tiny.pt_12_medium_upper.fontWeight};
  line-height: ${typography.tiny.pt_12_medium_upper.lineHeight};
  letter-spacing: ${typography.tiny.pt_12_medium_upper.letterSpacing};
  text-transform: ${typography.tiny.pt_12_medium_upper.textTransform};
`)

const InfoValue = styled.span(({
  theme: {
    palette, typography,
  },
}) => css`
  color: ${palette.black};
  font-size: ${typography.small.pt_13_semibold.fontSize};
  font-weight: ${typography.small.pt_13_semibold.fontWeight};
  line-height: ${typography.small.pt_13_semibold.lineHeight};
`)

interface MedicalExpandableProps {
  specification: string[]
  unitSpecialityCells: string[]
  nfzContract: boolean
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function MedicalExpandable({
  specification, unitSpecialityCells, nfzContract,
}: MedicalExpandableProps) {
  const { t } = useTranslation()

  return (
    <AdditionalInfo>
      <InfoSection>
        <InfoLabel>{`${t('placeme.pois.medical.nfz_contract')}:`}</InfoLabel>
        <InfoValue>
          {nfzContract
            ? t('generic.yes')
            : t('generic.no')}
        </InfoValue>
      </InfoSection>
      <InfoSection>
        <InfoLabel>{`${t('placeme.pois.medical.specification')}:`}</InfoLabel>
        <InfoValue>
          {specification?.length ? specification.join(', ') : '-'}
        </InfoValue>
      </InfoSection>
      <InfoSection>
        <InfoLabel>{`${t('placeme.pois.medical.unit_speciality_cells')}:`}</InfoLabel>
        <InfoValue>
          {unitSpecialityCells?.length ? unitSpecialityCells.join(', ') : '-'}
        </InfoValue>
      </InfoSection>
    </AdditionalInfo>
  )
}

export default MedicalExpandable
